import React, { Component } from 'react';
import Loadable from 'react-loadable';
import Loading from '../components/Loading';
import AsyncContext from '../components/AsyncContext';

class UpdateStore extends Component {
  constructor(props) {
    super();
    const { store, reducers, sagas, name } = props;
    store.injectReducers({
      name,
      reducers,
    });
    store.injectSagas({
      name,
      sagas,
    });
  }
  render() {
    return this.props.children;
  }
}

const createAsyncModule = name => {
  return Loadable({
    loader: () =>
      import(/* webpackChunkName: "[request]" */ `../modules/${name}/async`),
    loading() {
      return <Loading delay={250} />;
    },
    render(module, { store, ...props }) {
      const { Component, reducers, sagas, name } = module.default;
      return (
        <AsyncContext.Consumer>
          {store => (
            <UpdateStore
              reducers={reducers}
              store={store}
              sagas={sagas}
              name={name}
            >
              <main>
                <Component {...props} />
              </main>
            </UpdateStore>
          )}
        </AsyncContext.Consumer>
      );
    },
  });
};

export default createAsyncModule;
